import mitt from 'mitt';
// import Toastify from 'toastify-js';
import {
    on
} from 'delegated-events';
import validationService from './validationService';

const FIND_MEMBERSHIP_CLASS = '.js-find-membership';
const MONTH_CLASS = '.js-month-button';
const DAY_CLASS = '.js-calendar-day';
const RESOURCE_CLASS = '.js-resource';
const MEMBERSHIP_CONTINUE_CLASS = '.js-membership-continue';
const CALENDAR_CONTINUE_CLASS = '.js-calendar-continue';
const PRODUCTS_CONTINUE_CLASS = '.js-products-continue';
const RESOURCES_CONTINUE_CLASS = '.js-resources-continue';
const ADDITIONALINFO_CONTINUE_CLASS = '.js-additionalinfo-continue';
const GIFTAID_CONTINUE_CLASS = '.js-giftaid-continue';

const QUANTITY_INPUT_CLASS = ".js-quantity";
const DISABLED_CLASS = 'is-disabled';
import { createFrom } from './visitors-quantity-selector-validation';
import fetch from './fetchWithTimeout';

const DEFAULTS = {

};

const addDataJsParsed = (elements, tag = '') => {
    elements.forEach(x => {
        x.setAttribute(`data-js-parsed--${tag}`, '');
    });
}


function getErrorHtml(message) {
    return (
        `<div class="alert alert-warning">
            <i class="far fa-info-circle me-2"></i>
            ${message}
        </div>`
    );
}

class CalendarBookingApi {
    constructor(container, {
        ...options
    } = {}) {
        this.options = { ...DEFAULTS, ...options };
        this.container = container;
        this.quantity = 0;
        this.eventsLookup = container.dataset.eventsLookup === 'True';

        this.membershipContainer = container.querySelector('.js-membership-view');
        this.calendarContainer = container.querySelector('.js-calendar-view');
        this.productsContainer = container.querySelector('.js-product-view');
        this.resourcesContainer = container.querySelector('.js-resource-view');
        this.additionalInfoContainer = container.querySelector('.js-additionalinfo-view');
        this.giftAidContainer = container.querySelector('.js-giftaid-view');

        this.resourceIdInput = container.querySelector('[name="ResourceId"]');

        this.productMapId = "";

        this.dateInput = container.querySelector('[name="Date"]');

        this.nodeId = container.dataset.nodeId;
        this.productMapName = container.dataset.productMapName;
        this.resourceView = container.dataset.resourceView;
        this.additionalInfo = container.dataset.additionalInfo === 'True';
        this.giftAid = container.dataset.giftAid === 'True';
        this.resources = container.dataset.resources === 'True';
        this.membersBooking = container.dataset.membersBooking === 'True';

        this.init = this.init.bind(this);
        this.emitter = mitt();
        this.on = this.emitter.on;
        this.off = this.emitter.off;

        this.fetchMembership = this.fetchMembership.bind(this);
        this.fetchCalendar = this.fetchCalendar.bind(this);
        this.fetchProducts = this.fetchProducts.bind(this);
        this.fetchResources = this.fetchResources.bind(this);
        this.fetchAdditionalInfo = this.fetchAdditionalInfo.bind(this);
        this.fetchGiftAid = this.fetchGiftAid.bind(this);

        this.handleFindMembershipClick = this.handleFindMembershipClick.bind(this);
        this.handleMonthClick = this.handleMonthClick.bind(this);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.handleResourceClick = this.handleResourceClick.bind(this);
        this.handleQuantityChange = this.handleQuantityChange.bind(this);

        this.handleMembershipContinueClick = this.handleMembershipContinueClick.bind(this);
        this.handleCalendarContinueClick = this.handleCalendarContinueClick.bind(this);
        this.handleProductsContinueClick = this.handleProductsContinueClick.bind(this);
        this.handleResourcesContinueClick = this.handleResourcesContinueClick.bind(this);
        this.handleGiftAidContinueClick = this.handleGiftAidContinueClick.bind(this);

        this.handleMembershipChanging = this.handleMembershipChanging.bind(this);
        this.handleMembershipChanged = this.handleMembershipChanged.bind(this);

        this.handleCalendarChanging = this.handleCalendarChanging.bind(this);
        this.handleCalendarChanged = this.handleCalendarChanged.bind(this);

        this.handleProductsChanging = this.handleProductsChanging.bind(this);
        this.handleProductsChanged = this.handleProductsChanged.bind(this);

        this.handleResourcesChanging = this.handleResourcesChanging.bind(this);
        this.handleResourcesChanged = this.handleResourcesChanged.bind(this);

        this.handleAdditionalInfoChanging = this.handleAdditionalInfoChanging.bind(this);
        this.handleAdditionalInfoChanged = this.handleAdditionalInfoChanged.bind(this);

        this.handleGiftAidChanging = this.handleGiftAidChanging.bind(this);
        this.handleGiftAidChanged = this.handleGiftAidChanged.bind(this);

        this.handleQuantityChanged = this.handleQuantityChanged.bind(this);
        this.handleDayChanged = this.handleDayChanged.bind(this);
        this.handleResourceChanged = this.handleResourceChanged.bind(this);

        this.disableButton = this.disableButton.bind(this);
        this.enableButton = this.enableButton.bind(this);
        this.updateCurrentSelection = this.updateCurrentSelection.bind(this);
        this.updatePrices = this.updatePrices.bind(this);
        this.updateAvailability = this.updateAvailability.bind(this);

        this.validateMemberNumber = this.validateMemberNumber.bind(this);

        this.setLoading = this.setLoading.bind(this);
        this.setIdle = this.setIdle.bind(this);

        this.eventTypes = {
            membershipChanging: 'membershipChanging',
            membershipChanged: 'membershipChanged',
            calendarChanging: 'calendarChanging',
            calendarChanged: 'calendarChanged',
            productsChanging: 'productsChanging',
            productsChanged: 'productsChanged',
            resourcesChanging: 'resourcesChanging',
            resourcesChanged: 'resourcesChanged',
            additionalInfoChanging: 'additionalInfoChanging',
            additionalInfoChanged: 'additionalInfoChanged',
            giftAidChanging: 'giftAidChanging',
            giftAidChanged: 'giftAidChanged',
            dayChanged: 'dayChanged',
            quantityChanged: 'quantityChanged',
            resourceChanged: 'resourceChanged',
        };

        this.init(container);
    }

    disableButton(selector) {
        const button = this.container.querySelector(selector);

        if (button) {
            button.disabled = true;
            button.classList.add(DISABLED_CLASS);
        }
    }

    enableButton(selector) {
        const button = this.container.querySelector(selector);

        if (button) {
            button.disabled = false;
            button.classList.remove(DISABLED_CLASS);
        }
    }

    setLoading(container) {
        if (container) {
            container.classList.add('loading');
        }
    }

    setIdle(container) {
        if (container) {
            container.classList.remove('loading');
        }
    }

    // todo : move into a shared function
    updateCurrentSelection() {
        const selection = [];
        const prices = [];
        const quantityInputs = this.container.querySelectorAll(QUANTITY_INPUT_CLASS);

        quantityInputs.forEach(function (input) {
            const number = parseInt(input.value, 10);
            const price = parseFloat(input.dataset.price);

            if (number > 0) {
                selection.push(`${number} x ${input.dataset.label.trim()}`);

                if (price > 0) {
                    prices.push(price * number);
                }
            }
        });

        const quantityPlaceholders = this.container.querySelectorAll('.js-quantity-placeholder');

        if (quantityPlaceholders.length) {
            quantityPlaceholders.forEach(function (placeholder) {
                placeholder.innerHTML = selection.join(', ');
            });
        }

        const pricePlaceholders = this.container.querySelectorAll('.js-price-placeholder');

        if (pricePlaceholders.length) {
            if (prices.length > 0) {
                const totalPrice = prices.reduce(function (a, b) {
                    return a + b;
                });

                pricePlaceholders.forEach(function (placeholder) {
                    placeholder.innerHTML = `Total price: £${totalPrice.toFixed(2)}`;
                });
            }
            else {
                pricePlaceholders.forEach(function (placeholder) {
                    placeholder.innerHTML = '';
                });
            }
        }
        // console.log(selection);
    }

    updateAvailability() {
        const totalQuantity = this.quantity;

        this.container.querySelectorAll('.js-resource').forEach(function (timeslot) {
            const remainingSlots = parseInt(timeslot.dataset.remaining, 10);
            // console.log(timeslot, remainingSlots);

            if (remainingSlots < totalQuantity) {
                if (timeslot.dataset.event === 'True') {
                    const parent = timeslot.parentElement;
                    const input = parent.querySelector('input');
                    const availability = parent.querySelector('.availability');

                    input.disabled = true;

                    if (availability) {
                        availability.innerHTML = 'Sold out';
                    }
                }
                else {
                    timeslot.disabled = true;
                }
            }
        });
    }
    updatePrices() {
        // console.log('updatePrices');

        const quantityInputs = this.container.querySelectorAll(QUANTITY_INPUT_CLASS);
        const dayPricePlaceholders = this.container.querySelectorAll('.js-price');

        if (quantityInputs.length && this.dateInput.value && dayPricePlaceholders.length) {
            let items = [];

            quantityInputs.forEach((input) => {
                if (input.value && input.value !== "0") {
                    items.push({
                        plu: input.dataset.plu,
                        quantity: parseInt(input.value, 10)
                    })
                }
            });

            dayPricePlaceholders.forEach((placeholder) => {
                fetch(`/Umbraco/Surface/Calendar/GetDayPrices?date=${this.dateInput.value}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(items)
                })
                    .then(function (response) {
                        return response.json();
                    }).then(function (json) {
                        placeholder.innerHTML = json.price_formatted;
                    }).catch(function (err) {
                        // There was an error
                        console.warn('Something went wrong.', err);
                    });
            });
        }
        else {
            dayPricePlaceholders.forEach((placeholder) => {
                placeholder.innerHTML = '';
            });
        }
    }

    handleQuantityChange(e) {
        // console.log('handleQuantityChange', e);

        const quantityInputs = this.container.querySelectorAll(QUANTITY_INPUT_CLASS);

        let maxAdults = 999;
        let maxChildren = 999;
        let membershipSearch = document.getElementById('membership-search-result');

        if (membershipSearch) {
            maxAdults = parseInt(membershipSearch.dataset.adults, 10);
            maxChildren = parseInt(membershipSearch.dataset.children, 10);
        }

        let hasValue = false;
        let totalQuantity = 0;
        let totalAdults = 0;
        let totalChildren = 0;
        let requiresMembershipValidation = false;

        quantityInputs.forEach(function (input) {
            const number = parseInt(input.value, 10);
            const validate = input.dataset.validate == 'True';

            if (number > 0 && validate) {
                totalQuantity = totalQuantity + number;
                hasValue = true;

                const adults = parseInt(input.dataset.adults, 10);
                const children = parseInt(input.dataset.children, 10);
                const productContainer = input.closest('.js-product-container');

                totalAdults = totalAdults + (adults * number);
                totalChildren = totalChildren + (children * number);

                if (!requiresMembershipValidation) {
                    requiresMembershipValidation = productContainer.dataset.validationRequired === 'true';
                }
            }
        });

        if (hasValue && !requiresMembershipValidation) {
            this.enableButton(PRODUCTS_CONTINUE_CLASS);
        } else {
            this.disableButton(PRODUCTS_CONTINUE_CLASS);
        }

        const validationMessage = document.querySelector('.js-quantity-validation-message');

        if (totalAdults > maxAdults || totalChildren > maxChildren) {
            this.disableButton(PRODUCTS_CONTINUE_CLASS);

            if (validationMessage) {
                validationMessage.innerHTML = 'The number of tickets selected is more than your annual membership is allowed';
            }
        }
        else {
            this.enableButton(PRODUCTS_CONTINUE_CLASS);

            if (validationMessage) {
                validationMessage.innerHTML = '';
            }
        }

        if (totalQuantity === 0) {
            this.disableButton(PRODUCTS_CONTINUE_CLASS);
        }

        this.updateCurrentSelection();
        this.quantity = totalQuantity;
        this.emitter.emit(this.eventTypes.quantityChanged, { target: e.currentTarget })
    }

    handleMembershipChanging(e) {
        // console.log('handleMembershipChanging', e);

        this.setLoading(this.membershipContainer);
    }

    handleMembershipChanged(e) {
        // console.log('handleMembershipChanged', e);

        this.setIdle(this.membershipContainer);
    }

    handleCalendarChanging(e) {
        // console.log('handleCalendarChanging', e);

        this.setLoading(this.calendarContainer);
    }

    handleCalendarChanged(e) {
        // console.log('handleCalendarChanged', e);

        this.setIdle(this.calendarContainer);
    }

    handleResourcesChanging(e) {
        // console.log('handleResourcesChanging', e);

        this.disableButton(PRODUCTS_CONTINUE_CLASS);
        this.setLoading(this.resourcesContainer);
    }

    handleResourcesChanged(e) {
        // console.log('handleResourcesChanged', e);

        document.getElementById('timeslot-selection').scrollIntoView({
            behavior: 'smooth'
        });

        this.updatePrices();
        this.updateAvailability();
        this.updateCurrentSelection();
        this.setIdle(this.resourcesContainer);
    }

    handleAdditionalInfoChanging(e) {
        console.log('handleAdditionalInfoChanging', e);

        this.setLoading(this.additionalInfoContainer);
    }

    handleAdditionalInfoChanged(e) {
        console.log(e);
        console.log('handleAdditionalInfoChanged', e);

        document.getElementById('additionalinfo-selection').scrollIntoView({
            behaviour: 'smooth'
        });

        this.setIdle(this.additionalInfoContainer);
    }

    handleGiftAidChanging(e) {
        // console.log('handleGiftAidChanging', e);

        this.setLoading(this.giftAidContainer);
    }

    handleGiftAidChanged(e) {
        // console.log(e);
        // console.log('handleeGiftAidChanged', e);

        document.getElementById('giftaid-selection').scrollIntoView({
            behavior: 'smooth'
        });

        this.setIdle(this.giftAidContainer);
    }

    handleProductsChanging(e) {
        // console.log('handleProductsChanging', e);

        this.disableButton(CALENDAR_CONTINUE_CLASS);
        this.setLoading(this.productsContainer);
    }

    handleProductsChanged(e) {
        // console.log('handleProductsChanged', e);

        const singleDate = this.container.querySelector('.js-single-date');
        if (!singleDate) {
            document.getElementById('visitors-selection').scrollIntoView({
                behavior: 'smooth'
            });
        }

        const items = [];

        this.container.querySelectorAll(QUANTITY_INPUT_CLASS).forEach((input, index) => {
            input.addEventListener('change', this.handleQuantityChange);

            items.push({
                item_id: input.dataset.sku,
                item_name: input.dataset.label,
                currency: 'GBP',
                index: index + 1,
                item_category: this.productMapName,
                price: parseFloat(input.dataset.price),
                quantity: 0
            });
        });

        const testQuery = document.querySelector('.visitors-quantity-selector--visitor-type[data-validation-required]:not([data-js-parsed--visitors-quantity-selector-validation])');

        if (testQuery != null) {
            let thisDomQuery = document.querySelectorAll('.visitors-quantity-selector--visitor-type[data-validation-required]:not([data-js-parsed--visitors-quantity-selector-validation])');
            addDataJsParsed(thisDomQuery, "visitors-quantity-selector-validation");
            createFrom(thisDomQuery, this.validateMemberNumber);
        }


        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'view_item_list',
            funnel: this.productMapName,
            funnel_step: 'select_visitors',
            date: this.dateInput.value,
            item_list_name: this.productMapName,
            items: items
        });

        this.setIdle(this.productsContainer);
    }

    handleDayChanged(e) {
        // console.log('handleDayChanged', e);

        this.disableButton(PRODUCTS_CONTINUE_CLASS);
        this.disableButton(RESOURCES_CONTINUE_CLASS);
        this.disableButton(GIFTAID_CONTINUE_CLASS);
        this.enableButton(CALENDAR_CONTINUE_CLASS);
        this.disableButton(ADDITIONALINFO_CONTINUE_CLASS);

        this.productsContainer.innerHTML = '';

        if (this.resources) {
            this.resourcesContainer.innerHTML = '';
        }
        if (this.additionalInfo) {
            this.additionalInfoContainer.innerHTML = '';
        }
        if (this.giftAid) {
            this.giftAidContainer.innerHTML = '';
        }
    }

    handleResourceChanged(e) {
        // console.log('handleResourceChange', e);
        const calendarContainer = this.calendarContainer;
        const timeslotsBeforeTickets = calendarContainer.dataset.timeslotsBeforeTickets;


        this.enableButton(RESOURCES_CONTINUE_CLASS);

        if (timeslotsBeforeTickets == "true") {
            this.productsContainer.innerHTML = '';
        }

        if (this.additionalInfo) {
            this.additionalInfoContainer.innerHTML = '';
        }

        if (this.giftAid) {
            this.giftAidContainer.innerHTML = '';
        }
    }

    validateMemberNumber(validations, index, callback) {
        const validation = validations[index];
        const value = validation.field.value;
        const schemes = validation.btn.closest('.js-product-container').dataset.schemes
        const container = this.container;
        const enableButton = this.enableButton;
        const disableButton = this.disableButton;

        fetch(`/Umbraco/Surface/Memberships/ValidateMemberNumber?number=${value}&date=${this.dateInput.value}&schemes=${schemes}`, {
            method: 'POST'
        })
            .then(function (response) {
                return response.json();
            }).then(function (data) {
                // console.log(data);

                validation.valid = data.valid;

                if (callback) {
                    callback(validations, index, data.message);
                }

                const memberCardNumberInputs = container.querySelectorAll('.js-member-card-number');

                if (memberCardNumberInputs.length) {
                    const passesMemberValidation = Array.from(memberCardNumberInputs).every(x => x.classList.contains('is-valid'));

                    if (passesMemberValidation) {
                        enableButton(PRODUCTS_CONTINUE_CLASS);
                    }
                    else {
                        disableButton(PRODUCTS_CONTINUE_CLASS);
                    }
                }
            });
    }

    

    handleQuantityChanged(e) {
        // console.log('handleQuantityChanged', e);
        const calendarContainer = this.calendarContainer;
        const timeslotsBeforeTickets = calendarContainer.dataset.timeslotsBeforeTickets;

        if (this.resources && timeslotsBeforeTickets == "false") {
            this.resourcesContainer.innerHTML = '';
        }
        if (this.additionalInfo) {
            this.additionalInfoContainer.innerHTML = '';
        }
        if (this.giftAid) {
            this.giftAidContainer.innerHTML = '';
        }
    }

    handleMembershipContinueClick(e) {
        // console.log('click handleMembershipContinueClick');
        e.preventDefault();

        this.fetchCalendar(this.container.dataset.start);

        document.getElementById('visit-date').scrollIntoView({
            behavior: 'smooth'
        });
    }

    handleCalendarContinueClick(e) {
        // console.log('click handleCalendarContinueClick');

        if (e) {
            e.preventDefault();
        }

        const calendarContainer = this.calendarContainer;
        const timeslotsBeforeTickets = calendarContainer.dataset.timeslotsBeforeTickets;

        if (timeslotsBeforeTickets == "false") {
            this.fetchProducts(this.dateInput.value);
        }
        else {
            this.fetchResources(this.dateInput.value);
            this.updatePrices();
        }


        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'funnel_date',
            funnel: this.productMapName,
            funnel_step: 'date_selected',
            date: this.dateInput.value
        });

        // todo : merge if turns out the same
        const customLabel = document.querySelector('.js-who-is-visiting-label');

        if (customLabel) {
            fetch(`/Umbraco/Surface/Calendar/FormatDate/?date=${this.dateInput.value}`, {
                method: 'POST'
            })
                .then(function (response) {
                    return response.text();
                }).then(function (html) {
                    customLabel.innerHTML = ` on <strong>${html}</strong>`;
                });
        }
    }

    handleProductsContinueClick(e) {
        // console.log('click handleProductsContinueClick');
        e.preventDefault();

        const calendarContainer = this.calendarContainer;
        const timeslotsBeforeTickets = calendarContainer.dataset.timeslotsBeforeTickets;

        const items = [];
        let value = 0;
        this.container.querySelectorAll(QUANTITY_INPUT_CLASS).forEach((input, index) => {
            const number = parseInt(input.value, 10);

            if (number > 0) {
                items.push({
                    item_id: input.dataset.sku,
                    item_name: input.dataset.label,
                    currency: 'GBP',
                    index: index + 1,
                    item_category: this.productMapName,
                    price: parseFloat(input.dataset.price),
                    quantity: number
                });

                value = value + parseFloat(input.dataset.price) * number;
            }
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'add_to_cart',
            funnel: this.productMapName,
            funnel_step: 'cart_visitors',
            date: this.dateInput.value,
            currency: 'GBP',
            value: parseFloat(value.toFixed(2)),
            items: items
        });

        if (this.resources && timeslotsBeforeTickets == "false") {
            this.fetchResources(this.dateInput.value);

            // todo : merge if turns out the same
            const customLabel = document.querySelector('.js-choose-timeslot-label');

            if (customLabel) {
                fetch(`/Umbraco/Surface/Calendar/FormatDate/?date=${this.dateInput.value}`, {
                    method: 'POST'
                })
                    .then(function (response) {
                        return response.text();
                    }).then(function (html) {
                        customLabel.innerHTML = ` on <strong>${html}</strong>`;
                    });
            }
        }
        else if (this.additionalInfo) {
            this.fetchAdditionalInfo(this.dateInput.value);
        }
        else if (this.giftAid) {
            this.fetchGiftAid();
        }
        else {
            this.container.querySelector('form').submit();
        }

        this.disableButton(PRODUCTS_CONTINUE_CLASS);
    }

    handleGiftAidContinueClick(e) {
        // console.log('click handleGiftAidContinueClick', e);

        const giftAidInput = document.getElementById('GiftAid-Yes');

        if (giftAidInput) {
            const step = giftAidInput.checked ? 'gift_aid_accepted' : 'gift_aid_declined';

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'funnel_giftaid',
                funnel: this.productMapName,
                funnel_step: step,
                date: this.dateInput.value
            });
        }
    }

    handleResourcesContinueClick(e) {
        // console.log('click handleResourcesContinueClick', e);
        // e.preventDefault();

        const calendarContainer = this.calendarContainer;
        const timeslotsBeforeTickets = calendarContainer.dataset.timeslotsBeforeTickets;

        const items = [];
        let value = 0;
        this.container.querySelectorAll(QUANTITY_INPUT_CLASS).forEach((input, index) => {
            const number = parseInt(input.value, 10);

            if (number > 0) {
                items.push({
                    item_id: input.dataset.sku,
                    item_name: input.dataset.label,
                    currency: 'GBP',
                    index: index + 1,
                    item_category: this.productMapName,
                    price: parseFloat(input.dataset.price),
                    quantity: number
                });

                value = value + parseFloat(input.dataset.price) * number;
            }
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'add_to_cart',
            funnel: this.productMapName,
            funnel_step: 'cart_planetarium', // todo : this could be dynamic
            date: this.dateInput.value,
            currency: 'GBP',
            value: value,
            items: items
        });

        if (timeslotsBeforeTickets == "true") {
            this.fetchProducts(this.dateInput.value);
        }
        else if (this.additionalInfo) {
            this.fetchAdditionalInfo(this.dateInput.value);
        }
        else if (this.giftAid) {
            this.fetchGiftAid();
        } else {
            this.container.querySelector('form').submit();
        }
        this.disableButton(RESOURCES_CONTINUE_CLASS);
    }

    handleResourceClick(e) {
        if (e.currentTarget.disabled) {
            return;
        }

        const { resourceId, productMapId, event, eventName, eventStart } = e.currentTarget.dataset;

        // console.log('click handleResourceClick', e.currentTarget);
        const resource = this.container.querySelectorAll('.js-resource');

        resource.forEach(function (day) {
            day.classList.remove('selected');
        });

        if (e.currentTarget.constructor.name === 'HTMLButtonElement') {
            e.preventDefault();
        }

        if (event === 'True') {
            const label = this.container.querySelector('.js-event-placeholder');

            if (label) {
                label.innerHTML = `${eventName} at ${eventStart}`;
            }
        }

        e.currentTarget.classList.add('selected');

        this.resourceIdInput.value = resourceId;
        this.productMapId = productMapId;
        this.emitter.emit(this.eventTypes.resourceChanged, { resourceId })
    }

    handleAdditionalInfoContinueClick(e) {
        console.log('click handleAdditionalInfoContinueClick', e);

        const form = document.getElementById('calendar-booking');
        var isValid = window.validationService.isValid(form);

        if (isValid) {
            if (this.giftAid) {
                this.fetchGiftAid();
            }
            else {
                this.container.querySelector('form').submit();
            }
        }
    }

    handleDayClick(e) {
        // console.log('click handleDayClick');

        e.preventDefault();

        const days = this.container.querySelectorAll('.js-calendar-day');

        days.forEach(function (day) {
            day.classList.remove('selected');
        });

        e.currentTarget.classList.add('selected');

        const { date } = e.currentTarget.dataset;
        this.dateInput.value = date;
        this.emitter.emit(this.eventTypes.dayChanged, { date })
    }

    handleFindMembershipClick(e) {
        // console.log('click handleFindMembershipClick');
        e.preventDefault();

        const button = e.currentTarget;
        const emitter = this.emitter;
        const eventTypes = this.eventTypes;

        const isValid = !window.validationService.isFieldValid(document.getElementById('MembershipNumber'), true)
            && !window.validationService.isFieldValid(document.getElementById('LastName'), true)
            && !window.validationService.isFieldValid(document.getElementById('Postcode'), true);

        if (isValid) {
            button.disabled = true;
            emitter.emit(eventTypes.membershipChanging);
            const endpoint = `/Umbraco/Surface/Membership/Find?nodeId=${this.nodeId}`;

            fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    MembershipNumber: document.getElementById('MembershipNumber').value,
                    LastName: document.getElementById('LastName').value,
                    Postcode: document.getElementById('Postcode').value
                })
            })
                .then(function (response) {
                    return response.text();
                }).then(function (html) {
                    const container = document.querySelector('.js-membership-result');

                    container.innerHTML = html;
                    emitter.emit(eventTypes.membershipChanged);
                    button.disabled = false;
                }).catch(function (err) {
                    const container = document.querySelector('.js-membership-result');

                    container.innerHTML = getErrorHtml(`We're having trouble at this moment. Please try again shortly.`);
                    emitter.emit(eventTypes.membershipChanged);
                    button.disabled = false;
                    console.warn('Something went wrong.', err);
                });
        }
    }


    handleMonthClick(e) {
        // console.log('click handleMonthClick');

        e.preventDefault();

        const date = e.currentTarget.dataset.date;
        const find = e.currentTarget.dataset.find === "True";

        this.fetchCalendar(date, false, find);
    }

    fetchGiftAid() {
        const giftAidContainer = this.giftAidContainer;
        const emitter = this.emitter;
        const eventTypes = this.eventTypes;
        const endpoint = `/Umbraco/Surface/GiftAid/GetGiftAid?nodeId=${this.nodeId}`;

        emitter.emit(eventTypes.giftAidChanging);

        fetch(endpoint, {
            method: 'POST'
        })
            .then(function (response) {
                return response.text();
            }).then(function (html) {
                giftAidContainer.innerHTML = html;
                emitter.emit(eventTypes.giftAidChanged);

                const giftAidToggles = document.querySelectorAll('[name="GiftAid"]');

                if (giftAidToggles.length) {
                    giftAidToggles.forEach(function (toggle) {
                        toggle.addEventListener('change', function () {
                            document.querySelector(GIFTAID_CONTINUE_CLASS).disabled = false;
                        });
                    })
                }

            }).catch(function (err) {
                giftAidContainer.innerHTML = getErrorHtml(`We're having trouble at this moment. Please try again shortly.`);
                emitter.emit(eventTypes.giftAidChanged);
                console.warn('Something went wrong.', err);
            });
    }

    fetchResources(date) {
        const resourcesContainer = this.resourcesContainer;
        const emitter = this.emitter;
        const eventTypes = this.eventTypes;
        const type = this.eventsLookup ? 'EventList/GetEvents' : 'ResourceList/GetResources';
        const endpoint = `/Umbraco/Surface/${type}?nodeId=${this.nodeId}&resourceView=${this.resourceView}&date=${date}`;

        emitter.emit(eventTypes.resourcesChanging, { date: date });

        fetch(endpoint, {
            method: 'POST'
        })
            .then(function (response) {
                return response.text();
            }).then(function (html) {
                resourcesContainer.innerHTML = html;
                emitter.emit(eventTypes.resourcesChanged, { date: date });
            }).catch(function (err) {
                resourcesContainer.innerHTML = getErrorHtml(`We're having trouble at this moment. Please try again shortly.`);
                emitter.emit(eventTypes.resourcesChanged, { date: date });
                console.warn('Something went wrong.', err);
            });
    }

    fetchAdditionalInfo(date) {
        const additionalInfoContainer = this.additionalInfoContainer;
        const emitter = this.emitter;
        const eventTypes = this.eventTypes;

        console.log('...fetching additional info...');

        const endpoint = `/Umbraco/Surface/AdditionalInfo/GetAdditionalInfo?nodeId=${this.nodeId}&resourceView=${this.resourceView}&date=${date}&resourceId=${this.resourceIdInput.value}`;

        emitter.emit(eventTypes.additionalInfoChanging, { date: date });

        fetch(endpoint, {
            method: 'POST'
        })
            .then(function (response) {
                return response.text();
            }).then(function (html) {
                additionalInfoContainer.innerHTML = html;
                emitter.emit(eventTypes.additionalInfoChanged, { date: date });

                validationService();
            }).catch(function (err) {
                console.warn('Something went wrong.', err);
            });
    }

    fetchProducts(date) {
        const productsContainer = this.productsContainer;
        const emitter = this.emitter;
        const eventTypes = this.eventTypes;
        const department = this.container.querySelector('[name="Department"]').value;
        const endpoint = `/Umbraco/Surface/ProductList/GetProducts?nodeId=${this.nodeId}&productMapName=${this.productMapName}&date=${date}&department=${department}&productMapId=${this.productMapId}`;

        emitter.emit(eventTypes.productsChanging, { date: date });

        fetch(endpoint, {
            method: 'POST'
        })
            .then(function (response) {
                return response.text();
            }).then(function (html) {
                productsContainer.innerHTML = html;
                emitter.emit(eventTypes.productsChanged, { date: date });
            }).catch(function (err) {
                productsContainer.innerHTML = getErrorHtml(`We're having trouble at this moment. Please try again shortly.`);
                emitter.emit(eventTypes.productsChanged, { date: date });
                console.warn('Something went wrong.', err);
            });
    }

    fetchMembership() {
        // console.log('fetchMembership');
        const membershipContainer = this.membershipContainer;
        const emitter = this.emitter;
        const eventTypes = this.eventTypes;
        const endpoint = `/Umbraco/Surface/Membership/GetMembership?nodeId=${this.nodeId}`;

        emitter.emit(eventTypes.membershipChanging);

        fetch(endpoint, {
            method: 'POST'
        })
            .then(function (response) {
                return response.text();
            }).then(function (html) {
                membershipContainer.innerHTML = html;
                emitter.emit(eventTypes.membershipChanged);
                validationService();
            }).catch(function (err) {
                membershipContainer.innerHTML = getErrorHtml(`We're having trouble at this moment. Please try again shortly.`);
                emitter.emit(eventTypes.membershipChanged);
                console.warn('Something went wrong.', err);
            });
    }

    fetchCalendar(date = '', adjust = false, find = false) {
        // console.log('fetchCalendar');
        const calendarContainer = this.calendarContainer;
        const emitter = this.emitter;
        const eventTypes = this.eventTypes;
        let end = '';

        if (document.getElementById('membership-search-result')) {
            end = document.getElementById('membership-search-result').dataset.end;
        }

        const endpoint = `/Umbraco/Surface/Calendar/GetCalendar?nodeId=${this.nodeId}&date=${date}&adjust=${adjust}&find=${find}&end=${end}`;

        emitter.emit(eventTypes.calendarChanging, { date: date });

        fetch(endpoint, {
            method: 'POST'
        })
            .then(function (response) {
                return response.text();
            }).then(function (html) {
                calendarContainer.innerHTML = html;
                emitter.emit(eventTypes.calendarChanged, { date: date });
            }).catch(function (err) {
                calendarContainer.innerHTML = getErrorHtml(`We're having trouble at this moment. Please try again shortly.`);
                emitter.emit(eventTypes.calendarChanged, { date: date });
                console.warn('Something went wrong.', err);
            });
    }

    init(container) {
        if (!container) {
            return;
        }

        on('click', FIND_MEMBERSHIP_CLASS, (e) => {
            this.handleFindMembershipClick(e);
        });

        on('click', MONTH_CLASS, (e) => {
            this.handleMonthClick(e);
        });
        on('click', DAY_CLASS, (e) => {
            this.handleDayClick(e);
        });
        on('click', RESOURCE_CLASS, (e) => {
            this.handleResourceClick(e);
        });
        on('change', QUANTITY_INPUT_CLASS, (e) => {
            this.handleQuantityChange(e);
        });

        on('click', MEMBERSHIP_CONTINUE_CLASS, (e) => {
            this.handleMembershipContinueClick(e);
        });

        on('click', CALENDAR_CONTINUE_CLASS, (e) => {
            this.handleCalendarContinueClick(e);
        });

        on('click', PRODUCTS_CONTINUE_CLASS, (e) => {
            this.handleProductsContinueClick(e);
        });

        on('click', RESOURCES_CONTINUE_CLASS, (e) => {
            this.handleResourcesContinueClick(e);
        });

        on('click', ADDITIONALINFO_CONTINUE_CLASS, (e) => {
            this.handleAdditionalInfoContinueClick(e);
        });

        on('click', GIFTAID_CONTINUE_CLASS, (e) => {
            this.handleGiftAidContinueClick(e);
        });

        this.on(this.eventTypes.dayChanged, (e) => {
            this.handleDayChanged(e);
        });
        this.on(this.eventTypes.quantityChanged, (e) => {
            this.handleQuantityChanged(e);
        });
        this.on(this.eventTypes.resourceChanged, (e) => {
            this.handleResourceChanged(e);
        });
        this.on(this.eventTypes.membershipChanging, (e) => {
            this.handleMembershipChanging(e);
        });
        this.on(this.eventTypes.membershipChanged, (e) => {
            this.handleMembershipChanged(e);
        });
        this.on(this.eventTypes.calendarChanging, (e) => {
            this.handleCalendarChanging(e);
        });
        this.on(this.eventTypes.calendarChanged, (e) => {
            this.handleCalendarChanged(e);
        });
        this.on(this.eventTypes.productsChanging, (e) => {
            this.handleProductsChanging(e);
        });
        this.on(this.eventTypes.productsChanged, (e) => {
            this.handleProductsChanged(e);
        });
        this.on(this.eventTypes.resourcesChanging, (e) => {
            this.handleResourcesChanging(e);
        });
        this.on(this.eventTypes.resourcesChanged, (e) => {
            this.handleResourcesChanged(e);
        });
        this.on(this.eventTypes.additionalInfoChanging, (e) => {
            this.handleAdditionalInfoChanging(e);
        });
        this.on(this.eventTypes.additionalInfoChanged, (e) => {
            this.handleAdditionalInfoChanged(e);
        });
        this.on(this.eventTypes.giftAidChanging, (e) => {
            this.handleGiftAidChanging(e);
        });
        this.on(this.eventTypes.giftAidChanged, (e) => {
            this.handleGiftAidChanged(e);
        });

        if (!this.membersBooking) {
            const changeButton = this.container.querySelector('.js-change-date');

            if (!changeButton) {
                const singleDate = this.container.querySelector('.js-single-date');
                if (singleDate) {
                    this.fetchProducts(this.dateInput.value);
                }
                else {
                    this.fetchCalendar(this.container.dataset.start);
                }
            }
            else {
                changeButton.addEventListener('click', () => {
                    this.fetchCalendar(this.container.dataset.start);
                    this.handleDayChanged();
                });

                this.handleCalendarContinueClick();
            }
        } else {
            this.fetchMembership();
        }
    }

    destroy() {
        this.off('*');
        this.emitter = null;
    }
}

export default CalendarBookingApi;
